import {
  Box,
  Button,
  Paper,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from './auth.hook';

interface AuthProps {
  submitLabel: string;
  onSubmit: (credentials: {
    email: string;
    password: string;
  }) => Promise<void> | void;
  children: React.ReactNode;
  error?: string;
}

export const Auth = ({ submitLabel, onSubmit, children, error }: AuthProps) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'radial-gradient(circle at 20% 20%, #1e1e2f, #0f1115)',
        px: 0
      }}
    >
      <Paper
        elevation={8}
        sx={{
          width: '100%',
          maxWidth: 420,
          p: 4,
          borderRadius: 3,
          backdropFilter: 'blur(6px)',
          backgroundColor: 'rgba(20, 24, 32, 0.85)',
          border: '1px solid rgba(255,255,255,0.06)'
        }}
      >
        <Stack
          component="form"
          spacing={3}
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit({ email, password });
          }}
        >
          <Box>
            <Typography variant="h5" fontWeight={700} gutterBottom>
              Welcome back
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Log in to continue trading.
            </Typography>
          </Box>

          <TextField
            type="email"
            label="Email"
            variant="outlined"
            value={email}
            autoComplete="email"
            autoFocus
            onChange={(event) => setEmail(event.target.value)}
            error={!!error}
            helperText={error || ' '}
            fullWidth
          />
          <TextField
            type="password"
            label="Password"
            variant="outlined"
            value={password}
            autoComplete="current-password"
            error={!!error}
            helperText={error ? 'Check your credentials and try again.' : ' '}
            onChange={(event) => setPassword(event.target.value)}
            fullWidth
          />
          <Button
            type="submit"
            variant="contained"
            size="large"
            fullWidth
            sx={{ py: 1.2 }}
          >
            {submitLabel}
          </Button>
          {children}
        </Stack>
      </Paper>
    </Box>
  );
};
